/* ** Based on https://github.com/braceslab/vue-openseadragon */

<template>
  <div :id="id" />
</template>

<script>
import omit from "lodash/omit";

export default {
  props: {
    id: {
      type: String,
      default: "openseadragon-editor",
    },
    options: {
      type: Object,
    },
    i18n: {
      type: Object,
    },
    messages: {
      type: Object,
      default: () => ({
        "Tooltips.FullPage": "",
        "Tooltips.Home": "",
        "Tooltips.ZoomIn": "",
        "Tooltips.ZoomOut": "",
        "Tooltips.NextPage": "",
        "Tooltips.PreviousPage": "",
        "Tooltips.RotateLeft": "",
        "Tooltips.RotateRight": "",
        "Errors.Dzc": "",
        "Errors.Dzi": "",
        "Errors.Xml": "",
        "Errors.ImageFormat": "",
        "Errors.Security": "",
        "Errors.Status": "",
        "Errors.OpenFailed": "",
      }),
    },
  },
  data() {
    return {
      viewer: null,
    };
  },

  mounted() {
    this.$nextTick(() => this.setup());
  },
  methods: {
    setup() {
      if (!this.viewer && this.options) {
        this.translate();
        const _options = this.options;
        const OpenSeadragon = require("openseadragon");
        _options.id = this.id;
        this.viewer = OpenSeadragon(omit(_options, "tileSources"));
        this.viewer.open(_options.tileSources);
        this.viewer.zoomPerClick = 1
        this.viewer.addOnceHandler("open", () => {
          this.$emit("open");
        });
      }
    },
    resolve(object, key) {
      try {
        const _keys = key.split(".");
        let _cursor = object;
        for (const _key of _keys) {
          _cursor = _cursor[_key];
        }
        return _cursor;
      } catch (e) {
        return null;
      }
    },
    /**
	@see https://openseadragon.github.io/examples/ui-customize-tooltips/
      */
    translate() {
      if (!this.i18n || !this.messages) {
        return;
      }

      const _messages = this.i18n.messages[this.i18n.locale];
      const OpenSeadragon = require("openseadragon");
      for (const label in this.messages) {
        OpenSeadragon.setString(
          label,
          this.resolve(_messages, this.messages[label])
        );
      }
    },
    panTo({ x, y }, immediate) {
      const { Point } = require("openseadragon");
      const { Rect } = require("openseadragon");
      const size = 0.2
      var vp = this.viewer.viewport.viewerElementToViewportCoordinates(new Point(x, y ));
     var box = new Rect(vp.x - size / 2, vp.y - size / 2, size, size); 
     
     this.viewer.viewport.fitBounds(box);
    this.viewer.viewport.getBounds()
      this.viewer.viewport
        .panTo(new Point(x, y), false)
        .applyConstraints(false);
    },
    fitBoundsWithConstraints({ x, y, width, height }, immediate) {
      const { Rect } = require("openseadragon");
      this.viewer.viewport
        .fitBounds(new Rect(x, y, width, height), immediate)
        .applyConstraints(immediate);
    },
    addOverlay({ element, location }) {
      const { Overlay } = require("openseadragon");
      this.viewer.addOverlay(new Overlay({ element, location }));
    },
  },
};
</script>
